'use client';

import React from 'react';
import { Box, Typography, Toolbar } from '@mui/material';
import { styled } from '@mui/material/styles';

const HeaderContainer = styled(Box)(({ theme }) => ({
	position: 'relative',
	overflow: 'hidden',
	height: '100%',
	display: 'flex'
}));

const FirstHorizontalLine = styled(Box)(({ theme }) => ({
	position: 'absolute',
	bottom: -1,
	overflow: 'hidden',
	width: '55%',
	zIndex: 4,
	height: '60px',
	backgroundColor: theme.palette.vMaroon.main,
	clipPath: 'polygon(0 0, 85% 0, 100% 100%, 0 100%)',
	'&::after': {
		content: '""',
		position: 'absolute',
		top: 2,
		right: 2,
		trasform: 'translateY(-50%)',
		width: '100%',
		height: '100%',
		backgroundColor: theme.palette.vNavyBlue.main,
		clipPath: 'polygon(0 0, 85% 0, 100% 100%, 0 100%)'
	},
	[theme.breakpoints.up('md')]: {
		height: '110px'
	}
}));

const SecondHorizontalLine = styled(Box)(({ theme }) => ({
	position: 'absolute',
	bottom: 0,
	right: 0,
	height: '60px',
	width: '50%',
	zIndex: 3,
	borderBottom: `2px solid ${theme.palette.vMaroon.main}`,
	[theme.breakpoints.up('md')]: {
		height: '110px'
	}
}));

const Title = styled(Typography)(({ theme }) => ({
	fontWeight: 800,
	fontSize: `${theme.typography.pxToRem(42)} !important`,
	textAlign: 'center',
	color: theme.palette.text.primary,
	[theme.breakpoints.up('sm')]: {
		fontSize: `${theme.typography.pxToRem(50)} !important`
	},
	[theme.breakpoints.up('md')]: {
		fontSize: `${theme.typography.pxToRem(56)} !important`
	},
	[theme.breakpoints.up('lg')]: {
		fontSize: `${theme.typography.pxToRem(64)} !important`
	}
}));

const PageContainer = ({ children }) => {
	return (
		<Box component="main">
			<Toolbar />
			<HeaderContainer>
				<Box
					sx={{
						width: '100%',
						height: 'fit-content',
						px: 2,
						pb: { xs: 12, md: 24 },
						pt: 12,
						display: 'grid',
						placeContent: 'center'
					}}>
					<Title variant="h2">PRIVACY POLICY</Title>
				</Box>
				<FirstHorizontalLine />
				<SecondHorizontalLine />
			</HeaderContainer>
			{children}
		</Box>
	);
};

export default PageContainer;
